import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, Input } from '../../components/primitives';
import { useAuth } from './AuthContext';
import { AuthLayout } from './AuthLayout';
import { api } from '../../lib/api';
import { apiErrorMessage } from './authMessages';
import styles from './AuthPages.module.css';

export function RegisterPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);

    if (!fullName.trim()) {
      setError('Vyplňte jméno a příjmení.');
      return;
    }
    if (password.length < 6) {
      setError('Heslo musí mít alespoň 6 znaků.');
      return;
    }
    if (password !== passwordConfirm) {
      setError('Hesla se neshodují.');
      return;
    }

    setSubmitting(true);
    try {
      await api.post('/auth/register', {
        email,
        password,
        full_name: fullName.trim(),
      });
      // Účet vznikl — rovnou přihlásit a vpustit do aplikace.
      await login(email, password);
      navigate('/app', { replace: true });
    } catch (err) {
      setError(apiErrorMessage(err, 'Registrace se nezdařila.'));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout subtitle="Vytvořte si účet zdarma">
      <Card>
        <form className={styles.form} onSubmit={handleSubmit} noValidate>
          {error && (
            <div className={styles.error} role="alert">
              {error}
            </div>
          )}

          <Input
            label="Jméno a příjmení"
            type="text"
            autoComplete="name"
            required
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Jan Novák"
          />

          <Input
            label="E‑mail"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="vas@email.cz"
          />

          <Input
            label="Heslo"
            type="password"
            autoComplete="new-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Alespoň 6 znaků"
          />

          <Input
            label="Heslo znovu"
            type="password"
            autoComplete="new-password"
            required
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            placeholder="••••••••"
          />

          <Button type="submit" variant="primary" size="lg" fullWidth disabled={submitting}>
            {submitting ? 'Zakládám účet…' : 'Zaregistrovat se'}
          </Button>

          <div className={styles.switch}>
            Už máte účet?{' '}
            <Link to="/login" className={styles.link}>
              Přihlaste se
            </Link>
          </div>
        </form>
      </Card>
    </AuthLayout>
  );
}
